var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"width":_vm.width || '380',"type":"donut","options":_vm.options,"series":_vm.values}})
}
var staticRenderFns = []

export { render, staticRenderFns }